// extracted by mini-css-extract-plugin
module.exports = {"table":"Partner_table__BfIVb","actionTD":"Partner_actionTD__S8Q9b","deleteItem":"Partner_deleteItem__2BYvd","editItem":"Partner_editItem__9oFmu"};